import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=4a759d0d&scoped=true"
import script from "./captcha.vue?vue&type=script&lang=js"
export * from "./captcha.vue?vue&type=script&lang=js"
import style0 from "./captcha.vue?vue&type=style&index=0&id=4a759d0d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a759d0d",
  null
  
)

export default component.exports